import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ActiveItemTrending } from "./ActiveItemTrending";
import { AmountInCustomerCurrency } from "./AmountInCustomerCurrency";
import HomePageCard from "./HomePageCard";
import { MenuButton } from "./MenuButton";
import { type LocationState } from "./types";

type DefaultProps = {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  dataIcon?: "trending up" | "trending down" | "warning" | "suggestion" | "check";
  trend: number | string;
  trendColor?: string;
  trendDate?: string;
  value: number;
  disabled?: boolean;
  items: {
    title: string;
    path?: string;
    onClick?: () => void;
    eventName: string;
    description: string;
    locationState?: LocationState;
  }[];
  isValueInCurrency?: boolean;
  buttonText?: string;
};

export const TopCard = ({
  title,
  value,
  subtitle,
  dataIcon,
  trend,
  trendColor,
  trendDate,
  disabled = false,
  items,
  isValueInCurrency = true,
  buttonText,
}: DefaultProps) => (
  <HomePageCard title={title}>
    <Stack direction="column" sx={{ p: 3, height: 177 }} justifyContent="space-between">
      <Stack direction="column" alignItems="flex-start" spacing={1}>
        <Typography sx={{ fontSize: 44, fontWeight: 500, lineHeight: "44px" }}>
          {isValueInCurrency ? <AmountInCustomerCurrency amount={value} /> : value}
        </Typography>
        {subtitle ? (
          subtitle
        ) : (
          <ActiveItemTrending trend={trend} trendColor={trendColor} trendDate={trendDate} dataIcon={dataIcon} />
        )}
      </Stack>

      <MenuButton
        buttonText={buttonText}
        disabled={disabled}
        tooltip={
          disabled ? "You don't have the correct permissions to perform this action. Please contact your admin." : ""
        }
        items={items}
      />
    </Stack>
  </HomePageCard>
);
